import NavbarBottom from "@components/layout/navbar-bottom";
import NavbarTop from "@components/layout/navbar-top";
import { useSidebarCollapse } from "@hooks/contexts/SidebarCollapseContext";
import { ReactNode } from "react";
import NavbarLeft from "../navbar-left";

interface ContentProps {
  children: ReactNode;
}

export default function Content({ children }: ContentProps) {
  const { isCollapsed } = useSidebarCollapse();

  return (
    <div className={`wrapper ${isCollapsed ? "sidebar_minimize" : ""}`}>
      <NavbarLeft />
      <div className="main-panel">
        <NavbarTop />
        <div className="container">
          <div className="page-inner">{children}</div>
        </div>
        <NavbarBottom />
      </div>
    </div>
  );
}
